export const hrShiftSetupApi = {
    heading:[
        {
            head:"SL"
        },
        {
            head:"Shift Name"
        },
        {
            head:"Short Name"
        },
        {
            head:"Color"
        },
        {
            head:"Day of Week"
        },
        {
            head:"Day of Month"
        },
        {
            head:"Week of Month"
        },
        {
            head:"Start Time"
        },
        {
            head:"End Time"
        },
        {
            head:"Start Date"
        },
        {
            head:"End Date"
        },
        {
            head:"Actions"
        },
    ],
    data:[
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        sl:1138,
        shiftname:"Morning",
        shortname:"Mrn",
        color:"sky",
        dayofweek:"15",
        dayofmonth:"July", 
        weekofmonth:"2",
        starttime:"09:15",
        endtime:"13:15",
        startdate:"02-06-2023",
        enddate:"06-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
     
       
    ]
}